const WhyAndersonText = () => {
  return (
    <section
      data-testid="why-anderson-text-section"
      className="py-20 bg-[var(--ac-cream)]"
    >
      <div className="ac-container grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5 text-center md:text-left">
          <div className="eyebrow">Why Anderson</div>
          <h2 className="section-heading mt-3" data-testid="why-anderson-text-heading">
            Your Partner in <br />
            <span className="font-display text-[var(--ac-red)]">Building a Better Life</span>
          </h2>
        </div>
        <div className="lg:col-span-7 text-center md:text-left">
          <p className="text-[var(--ac-ink)] text-[17px] leading-relaxed">
            We know first-hand how stressful and frightening it can be to
            establish a career in a new country or to build a career in a
            country you've spent years in. With this deep understanding, we
            support you to overcome challenges and create a better life for you
            and your families. We are your partner in helping you become
            skilled, confident and in-demand employees.
          </p>
          <div className="mt-7 flex justify-center md:justify-start">
            <a
              href="/why-anderson"
              className="ds-btn ds-btn--primary"
              data-testid="why-anderson-text-btn"
            >
              Why Anderson
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyAndersonText;
